module.exports = __webpack_public_path__ + "img/image03@2x.26407326.webp";